import useAlbum from "./hooks/useAlbums";
import styles from './styles/HouseManagerProfile.module.css'


const baseURL = `${process.env.REACT_APP_API_URL}`

export default function AlbumsSection() {
    const { albums, selectedAlbum, fetchAlbumImages, loading, error } = useAlbum();


    const closeModal = () => {
        fetchAlbumImages(null);
    }

    if (loading) return <div>Loading Albums ...</div>
    if (error) return <div>{error}</div>

    return (
        <div className={styles.gallery}>
          <h2>Portfolio Gallery</h2>
          <div className={styles.galleryGrid}>
            {albums.length === 0 ? (
                <p>No albums available</p>
            ) : ( albums.map((album)=> (
              <div 
              key={album.id} 
              className={styles.album}
              onClick={() => fetchAlbumImages(album.id)}
              >
                <img
                  src={`${baseURL}${album.cover_image}`}
                  alt={`${album.title} cover`}
                  className={styles.albumCover}
                />
                <h3>{album.title}</h3>
              </div>
            )))}
            
          </div>
          {selectedAlbum && (
            <div className={styles.albumModal}>
              <div className={styles.albumModalContent}>
                <button className={styles.albumCloseButton} onClick={closeModal}>
                  &times;
                </button>
                <h2>{selectedAlbum.title}</h2>
                <div className={styles.albumImages}>
                  {selectedAlbum.images.map((image, index) => (
                    <img
                      key={index}
                      src={`${baseURL}${image.image_url}`}
                      alt={`album ${selectedAlbum.title}`}
                      className={styles.albumImage}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
    )
}